var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"logHistory"},[_c('app-datatable',{attrs:{"type":'view',"elements":_vm.dtElementsDetail,"collections":_vm.logData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }